var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('catalog-page',{attrs:{"send-gtm-data":true,"title":_vm.taxon.name,"banner":_vm.taxon.banner_url,"taxon":_vm.taxon,"case-scope":false}})}
var staticRenderFns = []

export { render, staticRenderFns }